import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';

import { AddButtonComponent } from './add-button.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule,
    MaterialModule
  ],
  exports: [AddButtonComponent],
  declarations: [AddButtonComponent]
})
export class AddButtonModule { }



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/add-button/add-button.module.ts